<template>
  <div class="vy-page">
    <header class="vy-banner">
      <span class="vy-circle vy-circle-1"></span>
      <span class="vy-circle vy-circle-2"></span>
      <span class="vy-circle vy-circle-3"></span>
      <img v-if="customLogoUrl" :src="customLogoUrl" class="vy-logo vy-logo-custom" alt="İzOnay" />
      <izonay-logo v-else class="vy-logo vy-logo-svg" aria-label="İzOnay" />
      <div class="vy-banner-text">
        <div class="vy-welcome" v-if="welcome">{{ welcome }}</div>
        <h1 class="vy-title" v-if="title">{{ title }}</h1>
        <p class="vy-description" v-if="description">{{ description }}</p>
      </div>
    </header>

    <main class="vy-main">
      <slot></slot>
    </main>
  </div>
</template>

<script>
import IzonayLogo from "./IzonayLogo.vue";

// Giriş öncesi ekranların ortak kabuğu: üstte lacivert bant (logo, karşılama metni), altında bandın üstüne binen kart alanı.
export default {
  name: "AuthShell",
  components: {
    IzonayLogo,
  },
  props: {
    welcome: { type: String, default: "" },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
  },
  computed: {
    // Müşteriye özel logo tanımlıysa o kullanılır (koyu logo lacivert zeminde beyaza çevrilir)
    customLogoUrl() {
      try {
        var logo = window.settings.customization.imgLogo;
        return logo ? "../img/" + logo : null;
      } catch (e) {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.vy-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F8F8F8;
  color: #092154;
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
}

.vy-banner {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  padding: calc(env(safe-area-inset-top, 0px) + 28px) 24px 72px 24px;
  border-radius: 0 0 24px 24px;
  background-color: #182F5E;
  color: #ffffff;
}

.vy-circle {
  position: absolute;
  border-radius: 50%;
  background-color: #172B58;
  pointer-events: none;
}

.vy-circle-1 { width: 120px; height: 120px; top: -30px; right: 24px; }

.vy-circle-2 { width: 160px; height: 160px; top: 40px; left: -70px; }

.vy-circle-3 { width: 120px; height: 120px; bottom: -40px; right: -30px; }

.vy-logo {
  position: relative;
  display: block;
  width: 132px;
  height: auto;
}

.vy-logo-custom {
  filter: brightness(0) invert(1);
}

/* Lacivert zeminde logonun lacivert kısımları beyaz olur */
.vy-logo-svg {
  color: #ffffff;
}

.vy-banner-text {
  position: relative;
  margin-top: 28px;
}

.vy-welcome {
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  color: #ffffff;
}

.vy-title {
  margin: 4px 0 0 0;
  font-weight: 600;
  font-size: 22px;
  line-height: 140%;
  color: #ffffff;
}

.vy-description {
  margin: 8px 0 0 0;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  color: rgba(255, 255, 255, 0.7);
}

.vy-main {
  position: relative;
  z-index: 1;
  flex: 1 0 auto;
  box-sizing: border-box;
  width: 100%;
  max-width: 480px;
  margin: -48px auto 0 auto;
  padding: 0 16px calc(env(safe-area-inset-bottom, 0px) + 24px) 16px;
}

</style>
